import React from 'react'
import { Container, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { IconChevronRight } from '@tabler/icons-react';

import CustomButton from '@components/button/customButton'

import { useScreenSize } from '@context/screenSizeContext'

import HomeHero from '@assets/image/home-hero-2.jpg'
import HomeHeroMobile from '@assets/image/home-hero-2-mobile.jpg'
import HomeAboutUs from '@assets/image/home-about-us.jpg'
import HomeMeditation from '@assets/image/home-meditation-2.png'
import HomeDonation from '@assets/image/home-donation-2.png'

import Carousel from './carousel'

import { UserApiEndpoints } from '@configuration/apiEndpoints';

import "./home.css";

export default function Home() {
  const { t } = useTranslation()
  const isSmallScreen = useScreenSize();
  const navigate = useNavigate()
  
  const { isFetching, isError, data } = useQuery({
    queryKey: ['getBanner'],
    queryFn: () =>
      axios.get(UserApiEndpoints.getBanner, { requiresAuth: false }),
    initialData: [],
    select: (res) => {
      const data = res?.data || []
      data?.sort((a, b) => a.sequence - b.sequence);
      return data || []
    },
  })

  return (
    <div>
      <div className='home-hero'>
        <img src={isSmallScreen ? HomeHeroMobile :  HomeHero} width={'100%'} height={'100%'} style={{objectFit: 'cover'}} alt='Chan is a flower'/>
      </div>
      <div className='home-section-2'>
        <Container className='headline-wrapper'>
          <div className='headline-divider'/>
          <Typography className='title' color='#7CA7AD'>
            {t('home-page.yearEvent', { year: dayjs().year() })}
          </Typography>
        </Container>
        <Container style={{maxWidth: '2000px', padding: '0px'}}>
          <Carousel data={data} loading={isFetching} isError={isError}/>
        </Container>
      </div>
      <Container className='home-section-3'>
        <div style={{flex: 1}}>
          <img src={HomeAboutUs} width={'100%'} style={{aspectRatio: "8/9"}} alt='profile'/>
        </div>
        <div style={{flex: 2, width: '100%'}}>
          <Typography className='tagline' color='#414042'>
            {t('home-page.zhushan')}
          </Typography>
          <Typography className='title'>
            {t('home-page.aboutUs')}
          </Typography>
          <div className='divider'/>
          <Typography className='description'>
            {t('home-page.aboutUsDesc')}
          </Typography>
          <CustomButton component={RouterLink} to="/about-us" hover={false} sx={{borderRadius: '40px', px: '30px', fontSize: '14px'}}>
            {t('home-page.learnMore')}
          </CustomButton>
        </div>
      </Container>
      <div className='home-section-4'>
        <Container>
          <Typography className='title'>
            {t('home-page.zhushanActivity')}
          </Typography>
          <div className='divider'/>
          <div className='button-wrapper'>
            <div onClick={()=>navigate('/activity')} className='button' style={{backgroundImage: `url(${HomeMeditation})`,}}>
              <Typography className='button-title'>
                {t('home-page.meditation')}
              </Typography>
              <div style={{position: 'absolute', bottom: 25, display: 'flex', alignItems: 'center', gap: 5}}>
                <Typography className='button-more'>
                  {t('home-page.viewMore')} 
                </Typography>
                <IconChevronRight size={15} color='#FFFFFF'/>
              </div>
            </div>
            <div onClick={()=>navigate('/support-us')} className='button' style={{backgroundImage: `url(${HomeDonation})`,}}>
              <Typography className='button-title'>
                {t('home-page.donation')}
              </Typography>
              <div style={{position: 'absolute', bottom: 25, display: 'flex', alignItems: 'center', gap: 5}}>
                <Typography className='button-more'>
                  {t('home-page.viewMore')} 
                </Typography>
                <IconChevronRight size={15} color='#FFFFFF'/>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Container className='home-section-5'>
        <div style={{backgroundColor: '#BBD0D3', padding: '40px 45px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <Typography className='title' color='#FFFFFF' textAlign={'center'}>
            {t('home-page.zenTogether')}
          </Typography>
          <Typography className='description' color='#FFFFFF' textAlign={'center'} fontWeight={500}>
            {t('home-page.zenTogetherDesc')}
          </Typography>
          <CustomButton component={RouterLink} to="/contact-us" color='#FFFFFF' hover={false} sx={{color: '#7FA7AC',  fontSize: '14px'}}>
            {t('contactUs')}
          </CustomButton>
        </div>
      </Container>
    </div>
  )
}
